import React from "react";
import { StyledNotification } from "../../dashboard.style";
import ProgressBar from "./ProgressBar";
import {StyledInnerProgressBarNotification} from "../notifications.style";

const ProgressBarNotification = ({ content, type }) => {
  return (
    <StyledNotification type={type}>
      <StyledInnerProgressBarNotification>
        <h3>{content.title}</h3>
        <p>{content.massage}</p>
        <ProgressBar sessionsAnalyzed={content.sessionsAnalyzed} type={type} maxSessions={content.maxSessions} />
      </StyledInnerProgressBarNotification>
    </StyledNotification>
  );
};

export default ProgressBarNotification;
